import {InjectionToken} from '@angular/core';
import { STATE_HANDLER_NAMES, ViewModes } from 'webcommon/lazy-load-commonjs/foxit';

// this is necessary, to just allow this as a constructor parameter
export const FoxitLicenseDtoToken = new InjectionToken<FoxitLicenseDto>('FoxitLicenseDto');

export interface FoxitLicenseDto {
  LicenseSN: string;
  LicenseKey: string;
  DefaultTool: STATE_HANDLER_NAMES;
  DefaultViewMode: ViewModes;
}

// example:
// DefaultTool: "select-text-annotation"
// DefaultViewMode: "single-page-view-mode"
// LicenseKey: "Key"
// LicenseSN: "SN"
